window.InitializeBothSearch = (options) => {
    return {
        searchInput : window.SearchInput(options),
        selected : false,
        search : window.Search({optimized : true, page : 1, distance : 100, workfields : [], orderBy : 'popularity', location : null, cachedSearch : null})
    }
}